export const isExternalSourceError = (filename: string): boolean => {
  // PerimeterX script errors are common and can be safely ignored.
  if (filename.includes('rf8vapwA/init.js')) {
    return true;
  }

  const injectedScriptSuffix = 'line 1 > injectedScript';
  if (filename.endsWith(injectedScriptSuffix)) {
    return true;
  }

  const errorWhitelist = [
    'www.skyscanner',
    'js.skyscnr.com',
    'css.skyscnr.com',
    'images.skyscnr.com',
    'skyscannertools.net',
  ];

  return !errorWhitelist.some((whitelist) => filename.indexOf(whitelist) > -1);
};
